import { IPodcastConfigurationDTO } from '@/modules/podcasts/dtos/podcast-configuration.dto';
import { IPodcastConfiguration } from '@/modules/podcasts/entities/podcast-configuration.entity';

class PodcastConfigurationMapper {
  public static toDomain(configure: IPodcastConfigurationDTO): IPodcastConfiguration {
    return {
      tone: configure.tom,
      format: configure.formato,
      duration: configure.duracao,
      approach: configure.abordagem,
      depth: configure.profundidade,
      language: configure.linguagem,
    };
  }

  public static toPersistence(configure: IPodcastConfiguration): IPodcastConfigurationDTO {
    return {
      tom: configure.tone,
      formato: configure.format,
      duracao: configure.duration,
      abordagem: configure.approach,
      linguagem: configure.language,
      profundidade: configure.depth,
    };
  }
}

export { PodcastConfigurationMapper };
